import { RichText, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import React from 'react';
import { ISiteInfo } from '../SiteInfoCard/SiteInfoCard';
interface IProps {
  siteAddressFormat: RichTextField;
  siteInfo: ISiteInfo | undefined;
  style?: React.CSSProperties;
}
const SiteLocationRichText: React.FC<IProps> = (props) => {
  const style = props.style || {};
  const RTFromSiteCore: RichTextField = props.siteAddressFormat || { value: '' };
  const siteInfo: ISiteInfo | undefined = props?.siteInfo;
  let newValue = '';

  if (siteInfo && Object.keys(siteInfo).length > 0) {
    // Get the mergeTags out from the RTFromSiteCore.value and store it in an array
    const originaValue: string = RTFromSiteCore.value || '';
    const mergeTagsInText: string[] = (originaValue.match(/\[(.*?)\]/g) || []).map((tag) =>
      tag.slice(1, -1)
    );

    const replaceMergeTags = (): string => {
      let replacedValue = originaValue;
      mergeTagsInText.forEach((tag) => {
        let tagValue = siteInfo[tag as keyof ISiteInfo] || '';
        if (tag === 'indication' && typeof tagValue === 'string') {
          tagValue = tagValue
            .split(',')
            .map((item) => item.trim())
            .join(' | ');
        }
        replacedValue = replacedValue.replace(new RegExp(`\\[${tag}\\]`, 'g'), tagValue as string);
      });

      const studyPhase = siteInfo['studyPhase' as keyof ISiteInfo] || '';
      const studyType = siteInfo['studyType' as keyof ISiteInfo] || '';
      const areStudyFieldsEmpty = !studyPhase && !studyType;

      if (areStudyFieldsEmpty) {
        // Remove leading bullets with spaces/nbsp when fields are empty
        // Matches patterns like "• •", "&bull; &bull;", or combinations with &nbsp; and newlines
        replacedValue = replacedValue
          .replace(/(\s|&nbsp;)*&bull;(\s|&nbsp;)*&bull;(\s|&nbsp;)*/g, '') // Remove • • with any whitespace
          .replace(/<p>(\s|&nbsp;)*&bull;(\s|&nbsp;)*/g, '<p>') // Remove leading • after <p> tag
          .replace(/(\s|&nbsp;)*&bull;(\s|&nbsp;)*<\/p>/g, '</p>'); // Remove trailing • before </p> tag
      }

      return replacedValue;
    };

    newValue = replaceMergeTags();
  } else {
    newValue = props.siteAddressFormat.value as string;
  }

  return <RichText data-testid="siteDetails" style={style} field={{ value: newValue }} />;
};

export default SiteLocationRichText;
